<template>
  <div class="height100" style="display: block">

    <template v-if="this.selectedItemID <= 0">
      <h1>Select task first...</h1>
    </template>

    <template v-else>

      <div class='task-tabs'>
        <b-tabs v-model='currentMiniTab'>
          <b-tab title="Task Info" @click="changeTab('generalInfo'); tabParam = 'generalInfo'" active>
          </b-tab>
          <b-tab title="Messages" @click="changeTab('messages'); tabParam = 'messages'" :title-link-class=" {abc:currentMiniTab }">
            <template slot="title">
              <span class='tab-msg-title'>Messages
                <!-- <span class='badge badge-pill badge-primary tab-msg-total' v-if="taskGeneralInfo.msg_total && taskGeneralInfo.msg_total != 0">{{taskGeneralInfo.msg_total}}</span> -->
                <span class="badge badge-pill badge-warning tab-msg-total" v-if="taskGeneralInfo.msg_new && currentMiniTab === 0">{{taskGeneralInfo.msg_new}}</span>
              </span>
            </template>
          </b-tab>
        </b-tabs>
      </div>

      <!-- TASK INFO -->
      <div class="card mb-3" :class='{darkTheme: darkTheme}' v-if="tabs.generalInfo">

        <div class="card-body scroll">
          <table id="task-table">

            <tr>
              <td class="align-top">Task Title:</td>
              <td style='font-weight: 600;'>
                {{taskGeneralInfo.tsk_title}}
              </td>
            </tr>

            <tr>
              <td class="align-top">Description:</td>
              <td>
                <vue-simple-markdown :lists='false' :source='taskGeneralInfo.description!==null?taskGeneralInfo.description:""'></vue-simple-markdown>
              </td>
            </tr>

            <tr>
              <td class="align-top">Priority:</td>
              <td>
                <span class="badge badge-danger" v-if="taskGeneralInfo.pri_id === 3">High</span>
                <span class="badge badge-primary" v-if="taskGeneralInfo.pri_id === 2 || taskGeneralInfo.pri_id === null">Normal</span>
                <span class="badge badge-warning" v-if="taskGeneralInfo.pri_id === 1">Low</span>
              </td>
            </tr>

            <tr>
              <td class="align-top">Task events:</td>
              <td>
                <span :class="convertStatus(taskGeneralInfo.sta_text)"></span>

                <span :class='statusColor(taskGeneralInfo.sta_text)'>{{taskGeneralInfo.sta_text}}
                  <span v-if="taskGeneralInfo.usr_ender_name !== null">by {{ taskGeneralInfo.usr_ender_name }}
                    {{ taskGeneralInfo.usr_ender_surname }} on {{
                    this.utcToLocal(taskGeneralInfo.timecompleted)
                    }}</span></span>
              </td>
            </tr>

            <tr>
              <td class="align-top">Created by:</td>
              <td>{{taskGeneralInfo.usr_creator_name}} {{taskGeneralInfo.usr_creator_surname}}</td>
            </tr>
            <tr>
              <td class="align-top">Time created:</td>
              <td v-if='taskGeneralInfo.tsk_timecreated !== null'>
                <span>{{parseMonthMomentUTCFix(taskGeneralInfo.tsk_timecreated) }}</span>
                {{$moment(utcToLocal(taskGeneralInfo.tsk_timecreated)).format('Do')}}
                <span class='year-date-format m-0' v-if='!isSameYear(taskGeneralInfo.tsk_timecreated)'>{{
                  parseYearMoment(taskGeneralInfo.tsk_timecreated) }}</span>
                <span class='time-date-space'>{{$moment(utcToLocal(taskGeneralInfo.tsk_timecreated)).format('HH:mm')}}</span>
              </td>
            </tr>
            <tr>
              <td class="align-top">Deadline:</td>
              <td v-if='taskGeneralInfo.tsk_deadline !== null' :style='{color:timeCriticalColor(taskGeneralInfo.time_critical)}'>
                <i :class='timeCriticalIcon(taskGeneralInfo.time_critical)' :title='timeCriticalTitle(taskGeneralInfo.time_critical)'></i>
                <span>{{parseMonthMomentUTCFix(taskGeneralInfo.tsk_deadline) }}</span>
                {{$moment(utcToLocal(taskGeneralInfo.tsk_deadline)).format('Do')}}
                <span class='year-date-format m-0' v-if='!isSameYear(taskGeneralInfo.tsk_deadline)'>{{
                  parseYearMoment(taskGeneralInfo.tsk_deadline) }}</span>
                <span class='time-date-space'>{{$moment(utcToLocal(taskGeneralInfo.tsk_deadline)).format('HH:mm')}}</span>
              </td>
            </tr>

            <tr v-if="taskGeneralInfo.tags !== null">
              <td class="align-top">Tags:</td>
              <td>
                <span class="badge badge-orange" v-for="(tag,index) in taskGeneralInfo.tags" :key='index'>{{
                  tag.text }}</span>
              </td>
            </tr>

            <tr>
              <td class="align-top">Working:</td>
              <td>
                <ul class="list-unstyled">
                  <li class="media mt-2" style="align-items: center;" v-for="(user,index) in taskGeneralInfo.usrworking"
                    :key='index'>

                    <avatar v-if='user.usrimg === null' :username="user.name + ' ' + user.surname" :rounded="true"
                      :size="40"></avatar>
                    <avatar v-else :src="getAvatar(user.usrimg)" :rounded="true" :size="40"></avatar>

                    <div class="media-body">
                      <div class="media-body">
                        <h5 class="my-auto ml-2">{{user.name}} {{user.surname}}
                          <small> <span class="badge badge-pill badge-primary"> {{user.email}} </span></small>
                        </h5>
                      </div>
                    </div>

                  </li>

                </ul>
              </td>
            </tr>

          </table>
          <div class="text-right">

            <button class="btn btn-danger" type="button" v-if="taskGeneralInfo.only_worker === 1" @click.prevent="taskStatus(5)">
              Reject task
            </button>

            <div class="dropdown save" v-if="taskGeneralInfo.can_mark === 1">
              <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                v-if="taskInProgress">
                Mark this task as...
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" @click.prevent="taskStatus(3)">Completed</a>
                <a class="dropdown-item" v-if="taskGeneralInfo.can_edit !== 1" @click.prevent="taskStatus(4)">Failed</a>
                <a class="dropdown-item" v-if="taskGeneralInfo.can_edit === 1" @click.prevent="taskStatus(6)">Cancelled</a>
              </div>
            </div>

            <button v-if="taskGeneralInfo.can_edit === 1 && taskGeneralInfo.sta_text === 'In Progress'" type="button"
              class="btn btn-success save" @click="editTaskBtn()">
              Edit
              <span class="fa fa-chevron-right"></span>
            </button>
          </div>
        </div>
      </div>

      <!-- CHAT - UPDATES -->
      <feed-element ref='feed' :class='{darkTheme: darkTheme}' v-if="tabs.messages" />

    </template>

  </div>
</template>

<script>
import { baseURL } from "@/api/config.js";
import { store } from "@/store/index.js";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import { api } from "@/api/index";
import { mapState } from "vuex";
import FeedElement from "@/components/Feed/FeedElement";
import Avatar from "vue-avatar";

export default {
  components: {
    Multiselect,
    FeedElement,
    Avatar
  },

  data() {
    return {
      confirmModal: false,

      tabParam: undefined,
      editFields: false,

      tabs: {
        generalInfo: true,
        messages: false
      },

      taskGeneralInfo: [],
      showInactive: false,
      inactiveUsers: [],

      edit: {
        name: undefined,
        description: undefined,
        status: undefined,
        deadline: undefined,
        estTime: undefined,
        timespent: undefined,
        progress: undefined
      },

      valueUser: [],
      optionsUser: [],

      taskInfo: [],
      showAllTags: false,
      showAllTagsID: undefined,
      stepInfo: [],

      project: {
        title: undefined,
        description: undefined,
        users: undefined,
        deadline: undefined,
        estDate: undefined
      },

      config: {
        wrap: false, // set wrap to true only when using 'input-group'
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i:S",
        altFormat: "F	j, Y H:i",
        altInput: true,
        minDate: "today"
      },
      estDate: {
        wrap: false, // set wrap to true only when using 'input-group'
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i:S",
        altFormat: "F	j, Y H:i",
        altInput: true,
        minDate: "today"
      }
    };
  },
  computed: {
    taskInProgress() {
      return this.taskGeneralInfo.sta_text === "In Progress";
    },
    currentMiniTab: {
      get() {
        if (this.tabs.generalInfo) return 0;
        if (this.tabs.messages) return 2;
        return -1;
      },
      set() {}
    },
    inProgressExists() {
      let exists = false;

      for (var i = 0; i < this.taskInfo.length; i++) {
        if (this.taskInfo[i].sta_text === "In Progress") {
          exists = true;
        }
      }
      return exists;
    },
    generalInfoTrue() {
      return this.tabs.generalInfo;
    },
    tagStringArray() {
      let niz = [];
      for (var i = 0; i < this.valueTag.length; i++) {
        niz.push(this.valueTag[i].text);
      }
      return JSON.stringify(niz);
    },
    userStringArray() {
      let niz = [];
      for (var i = 0; i < this.valueUser.length; i++) {
        niz.push(this.valueUser[i].id);
      }
      return JSON.stringify(niz);
    },
    selectedItemID() {
      var a = store.getters.selectedItemID;
      if (!a) return 0;
      else return a;
    },
    selectedProjectID() {
      var a = store.state.sidebarItemSelection[0];
      if (!a) return 0;
      else return a;
    },
    deadlineDate() {
      return this.utcToLocal(this.taskInfo.deadline);
    },
    createdDate() {
      return this.utcToLocal(this.taskInfo.createdDate);
    },
    ...mapState({
      tabIndex: "currentTabIndex",
      itemEditClick: "itemEditClick",
      darkTheme: state => state.darkTheme
    })
  },
  watch: {
    selectedItemID: function(val, oldVal) {
      if (val !== 0) {
        if (!this.tabParam || this.tabParam === "generalInfo") {
          this.changeTab("generalInfo");
        } else if (this.tabParam === "messages") {
          this.$refs.feed.changeSelectedTask();
          this.changeTab("messages");
        }
      }
    }
  },
  methods: {
    timeCriticalTitle(t_cr) {
      if (t_cr <= 0) return "Expired";
      if (t_cr < 0.2) return "Deadline close";
    },
    timeCriticalIcon(t_cr) {
      if (t_cr <= 0) return "fa fa-times";
      if (t_cr < 0.2) return "fa fa-exclamation-triangle";
    },
    timeCriticalColor(t_cr) {
      if (t_cr <= 0) return "#de4c4c"; // RED
      if (t_cr < 0.2) return "#a79923"; // YELLOW
    },
    convertStatus(sta_text) {
      switch (sta_text) {
        case "In Progress":
          return "td-blue fa fa-hourglass";
        case "Completed":
          return "td-green fa fa-check";
        case "Failed":
          return "td-red fa fa-times";
        case "Cancelled":
          return "td-orange fa fa-ban";
        case "Rejected":
          return "td-yellow fa fa-ban";
        default:
          return "NO IMPLEMENT";
      }
    },
    statusColor(sta_text) {
      switch (sta_text) {
        case "In Progress":
          return "td-blue";
        case "Completed":
          return "td-green";
        case "Failed":
          return "td-red";
        case "Cancelled":
          return "td-orange";
        case "Rejected":
          return "td-yellow";
      }
    },
    getAvatar(image) {
      let netIcon = "";
      if (image) {
        netIcon = baseURL + image + "?sid=" + localStorage.sid;
      }
      return netIcon;
    },
    async taskStatus(parameter) {
      try {
        await api.changeTaskStatus(parameter, this.selectedItemID);
        this.resetTaskView();
      } catch (e) {}
    },
    editTaskBtn(taskID) {
      store.commit("itemEditClick", {
        id: this.selectedItemID
      });
    },
    async getGeneralInfo(taskID) {
      if (!taskID) return;
      try {
        let res = await api.loadTaskInfo(taskID);
        if (res) {
          if (taskID) this.taskGeneralInfo = res.data.data[0];
        } else {
          store.commit("setSidebarItemSelection", {
            tabIndex: 1,
            id: undefined
          });
        }
      } catch (e) {}
    },

    changeTab(parameter) {
      if (parameter === "generalInfo") {
        this.tabs.generalInfo = true;
        this.tabs.messages = false;
        this.getGeneralInfo(this.selectedItemID);
      }

      if (parameter === "messages") {
        this.tabs.generalInfo = false;
        this.tabs.messages = true;
      }
    },

    showInactiveUsers() {
      //TRAZITI OD CELAVOG API KOJI VRACA SVE NEAKTIVNE USERE
    },
    resetTaskView() {
      store.commit("itemActionReset");
      store.commit("resetTaskView");

      store.commit("incDirtyCounter");
    },
    removeUser(removedOption) {
      let user = {
        id: removedOption.id,
        name: removedOption.name,
        email: removedOption.email
      };
      this.valueUser.push(user);
    },
    async loadTags() {
      try {
        let res = await api.loadTags(
          this.selectedProjectID,
          this.$refs.tagSearchString.search
        );
        if (res.data.data) {
          this.optionsTag = res.data.data;
        }
      } catch (e) {}
    },
    reportWritingToDB(result) {
      if (result.data.status === "OK") {
        store.commit("toastStatus", {
          message: "Step is edited."
        });
      } else {
        store.commit("toastStatus", {
          ok: false,
          message: result.data.message
        });
      }
    },
    addTag(newTag) {
      const tag = {
        text: newTag
      };
      this.valueTag.push(tag);
    },
    async getTaskInfo(taskID) {
      let res = await api.getTaskInfo(taskID);
      if (!res.data.data) return;
      this.taskInfo = res.data.data;
      for (let i = 0; i < res.data.data.length; i++) {
        let id = this.taskInfo[i].pri_id;
        switch (id) {
          case 1:
            this.taskInfo[i].pri_badge = "badge-info";
            break;
          case 2:
            this.taskInfo[i].pri_badge = "badge-warning";
            break;
          case 3:
            this.taskInfo[i].pri_badge = "badge-danger";
            break;
        }
      }
    }
  },
  mounted() {
    this.getGeneralInfo(this.selectedItemID);
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style scoped>
h1 {
  text-align: left;
}

.tabs {
  display: flex;
  justify-content: center;
  left: 0;
  right: 0;
}

.save {
  display: inline-block;
  margin-left: auto;
}

.save .fa {
  margin: 0 10px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  border: 1px solid #c3c1c13d;
}

.card-header.darkTheme {
  background: var(--dark);
  color: var(--sec-color);
}

.card-body td:first-child {
  color: #adadad;
  padding-right: 30px;
}

.card.darkTheme {
  background: var(--dark-super);
  color: var(--sec-color) !important;
}

.table-hover tbody tr:hover {
  background-color: #6f6f6f1f;
}

.badge {
  margin: 0.125rem;
}

.pointer {
  cursor: pointer;
}

.pad-0 {
  padding: 0;
}

.slika {
  border: 1px solid #333;
}

label {
  padding-top: 10px;
}

.stepInfoShow {
  width: 100%;
}

.stepInfoShow td {
  width: 50%;
  padding: 5px 0;
}

.header {
  display: flex;
  padding: 10px 20px;
  justify-content: space-between;
  color: initial;
}

.link {
  cursor: pointer;
  text-decoration: underline;
}

.back-button {
  flex-grow: 0.1 !important;
}

button.nav-item {
  margin: 5px;
}

.height100 {
  margin-top: 21px;
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;
}

td.align-top {
  width: 25%;
}

.tab-msg-title > span {
  position: relative;
}

.tab-msg-title > .tab-msg-total {
  z-index: 1;
}

.tab-msg-title > .tab-msg-new {
  left: -13px;
  z-index: 0;
}

.dropdown.save .dropdown-item:hover {
  background: #868a904f;
}

.stepInfoShow tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.poslednjiRed {
  border-bottom: 0px !important;
}

nav .btn-warning.active {
  background-color: #ffe186 !important;
  border-color: #ffe186 !important;
}

input[type="text"i]:disabled {
  background-color: #ffffff;
  border: 0;
  color: #000000;
  font-weight: 400;
}

textarea:disabled {
  background-color: #ffffff;
  border: 0;
  color: #000000;
  font-weight: 400;
}

#task-table td {
  padding: 5px 10px;
}

#task-table {
  width: 100%;
}

td .form-control {
  border: none;
  border-bottom: 1px solid #a09e9e57;
  padding-left: 0px;
}

.fa-hand-point-right {
  cursor: pointer;
}

.vue-avatar--wrapper {
  font: 20px Saira !important;
}

.scroll {
  overflow: auto;
  max-height: 85vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Content/Task/TaskView.vue